import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c1c453a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6c1c453a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c453a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1c453a')) {
      api.createRecord('6c1c453a', component.options)
    } else {
      api.reload('6c1c453a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c1c453a&scoped=true&", function () {
      api.rerender('6c1c453a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-store-manage/modules/insurance-dialog/index.vue"
export default component.exports